module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-2a"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("By the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flight Unlimited")]), _vm._v(" (with Eric Müller) Müller & Carson, London, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flight Unlimited ’95")]), _vm._v(" (with Eric Müller) Carson, Morningside, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flight Fantastic: The Illustrated History of Aerobatics")]), _vm._v(", Foulis/Haynes, Sparkford, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Welgevonden: Wilderness in the Waterberg")]), _vm._v(", Lapalala, Johannesburg, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeff Beck: Crazy Fingers")]), _vm._v(", Backbeat Books, San Francisco, 2001")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard III: The Maligned King")]), _vm._v(", The History Press, Stroud, 2008 and 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard III: A Small Guide to the Great Debate")]), _vm._v(", Imprimis, Norwich, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Finding Richard III: The Official Account of the Retrieval and Reburial Project")]), _vm._v(" (Ed.) (with J. Ashdown-Hill, D. Johnson, W. Johnson and P.J. Langley), Imprimis, Norwich, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "aut_"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Duke of Gloucester as Lord Protector and High Constable of England")]), _vm._v(", Imprimis, Norwich, 2015.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73599c68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002_About_author.vue
// module id = 63
// module chunks = 0